<div *ngIf="showNudge" class="nudge-container" [ngClass]="{
    'bottom-right': position === 'bottom-right'
}">
    <ng-content></ng-content>
</div>
